import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartSidebar = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m8.246 2.652a4.567 4.567 0 0 1 6.422 0 4.466 4.466 0 0 1 0 6.364l-6.176 6.117a.7.7 0 0 1 -.984 0l-6.18-6.121a4.479 4.479 0 0 1 -1.328-3.18c0-1.195.48-2.34 1.328-3.18a4.574 4.574 0 0 1 6.426 0l.246.243zm-.246 11.012 4.941-4.894.739-.735a3.095 3.095 0 0 0 0-4.406 3.155 3.155 0 0 0 -4.446 0l-.742.734a.7.7 0 0 1 -.984 0l-.742-.734a3.167 3.167 0 0 0 -4.446 0 3.095 3.095 0 0 0 0 4.406zm0 0",
		fill: "#fff"
	})
});
export default SvgHeartSidebar;
